export function rateArticle() {
  $(document).ready(function () {
    let postId = $("body")
      .attr("class")
      .match(/postid-\d+/)[0];
    let $question = $(".rate-question");
    let $thanks = $(".rate-thanks");
    let $buttons = $(".rate-buttons button");

    $(".rate-article").css("visibility", "visible");

    if (localStorage.getItem(postId + "-feedback")) {
      $question.hide();
      $thanks.show();
    } else {
      $question.show();
      $thanks.hide();
    }

    $buttons.on("click", function () {
      let answerValue = $(this).data("answer");

      localStorage.setItem(postId + "-feedback", answerValue);

      if (answerValue === "yes") {
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "article_like_button",
          eventLabel: "",
          eventContent: "",
          eventPosition: "",
          eventContext: "",
        });
      } else if (answerValue === "no") {
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "article_dislike_button",
          eventLabel: "",
          eventContent: "",
          eventPosition: "",
          eventContext: "",
        });
      }

      $question.slideUp(100);
      $thanks.slideDown(100);
    });
  });
}
